import { COMMON } from "../../../util/localizations";

const TRANSLATIONS = {
    en: {
        amount: COMMON.en.amount,
        approveSuccess: 'Successfully approved offer, "{0}".',
        boardName: COMMON.en.boardName,
        from: 'From Address',
        noBuyOffers: `You haven't made an offer to buy a ${ COMMON.appName } NFT`,
        noSellOffers: `You haven't received an offer to sell your ${ COMMON.appName } NFT(s)`,
        offersBuy: 'Buy',
        offersSell: 'Sell',
        status: 'Status',
        subtitle: `All active offers made to and from, "{0}".`,
        title: COMMON.en.offers,
        to: 'To Address',
        tokenId: "Token"
        
    }
}

export default TRANSLATIONS